export default __webpack_public_path__ + "static/media/bg-modal-dark.2b22c461.png";